import { DOMHelpers } from "../helpers/domhelpers";
import { ZoomImage } from "./zoom-image";
import { ZoomImageDefinition } from "./zoom-image-definition";
import { Time } from "./time";
import { Tween } from "./tween";

export class GUIController
{
    public element:HTMLElement;

    private container:HTMLElement;
    
    private loader:HTMLElement;
    private info:HTMLElement;
    private hint:HTMLElement;

    public hintVisible:boolean = false;

    private infoAnimDuration:number = 0.75;
    private infoAnimTween:Tween<number> = null;
    private hintTween:Tween<number> = null;

    public constructor (container:HTMLElement)
    {
        this.container = container;
        
        this.createGUI();
    }

    private createGUI()
    {
        this.element = document.createElement('div');
        this.element.className = "zoomgui";
        this.element.style.cssText = "position:absolute; left:0; top:0; right:0; bottom:0;"
        
        this.element.innerHTML = `
        <div class="zoominfo">
            <div class="title">NAZOV OBRAZU</div>
            <div class="year">ROK VYROBY</div>
            <div class="author">MENO AUTORA</div>
        </div>
        <div class="zoomhint"></div>
        <div class="zoomloader">0%</div>
        `;

        this.loader = this.element.getElementsByClassName("zoomloader")[0] as HTMLElement;
        this.info = this.element.getElementsByClassName("zoominfo")[0] as HTMLElement;
        this.hint = this.element.getElementsByClassName("zoomhint")[0] as HTMLElement;
        this.info.style.display = "none";
        this.hideLoader();
    }

    /**
     * Called in master update loop, used to update any animated transitions
     */
    public update()
    {
        // update transitions
        if (this.infoAnimTween != null)
        {
            this.infoAnimTween.update(Time.deltaTime);
            this.info.style.transform = `translate(${this.infoAnimTween.value()}%,0)`;
            if (this.infoAnimTween.finished())
                this.infoAnimTween = null;
        }

        if (this.hintTween != null)
        {
            this.hintTween.update(Time.deltaTime);
            this.hint.style.opacity = `${this.hintTween.value()}`;
            if (this.hintTween.finished())
            {
                this.hintTween = null;
                if (!this.hintVisible) this.hint.style.display = "none";
            }
        }
    }

    public hideLoader()
    {
        this.loader.style.display = "none";
    }

    public setLoader(percentage:number)
    {
        this.loader.innerText = `${percentage}%`;
        this.showLoader();
    }

    public showLoader()
    {
        this.loader.style.display = "block";
    }

    public setInfo(image:ZoomImageDefinition)
    {
        let title = this.info.getElementsByClassName("title")[0] as HTMLElement;
        let year = this.info.getElementsByClassName("year")[0] as HTMLElement;
        let author = this.info.getElementsByClassName("author")[0] as HTMLElement;

        title.innerText = image.title;
        year.innerText = image.year;
        author.innerText = image.author;
    }

    public hideInfo(duration:number)
    {        
        this.info.style.transform = "translate(0,0)";
        this.infoAnimTween = new Tween<number>(0, 100, duration);        
    }

    public showInfo(duration:number)
    {
        this.info.style.display = "block";
        this.info.style.transform = "translate(100%,0)";
        this.infoAnimTween = new Tween<number>(100, 0, duration);
    }

    public showHint()
    {
        if (!this.hintVisible)
        {            
            this.hintVisible = true;
            this.hint.style.display = "block";
        }
    }

    public hideHint()
    {
        if (this.hintVisible)
        {
            this.hintVisible = false;
            this.hintTween = new Tween<number>(1,0,0.2);            
        }
    }
}